import { useFiatDisplay } from '@/hooks/useFiatDisplay';

/** Trade volume in the selected currency; a dash when zero or missing. */
export function CompletedTradeVolumeCell({ volumeUsd }: { volumeUsd: number | undefined }) {
  const { formatFiat } = useFiatDisplay();

  if (!volumeUsd) return <>-</>;
  return <>{formatFiat(volumeUsd)}</>;
}
